var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5003 24.7254L25.5118 26.5826L21.9257 19.1541H14.7533M14.7533 19.1541H13.5578L11.167 9.24927H13.5578L13.8898 11.9999M14.7533 19.1541L13.8898 11.9999M13.8898 11.9999H19.167",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9477 24.9383C21.3089 24.2995 20.1973 24.5427 19.6414 25.2548C18.5015 26.7153 16.7246 27.6543 14.7285 27.6543C11.2884 27.6543 8.49967 24.8656 8.49967 21.4256C8.49967 19.8108 9.11419 18.3395 10.1221 17.2328C10.5096 16.8073 10.7055 16.2207 10.5402 15.6695C10.2711 14.7725 9.21566 14.3817 8.54273 15.0329C6.87178 16.6501 5.83301 18.9165 5.83301 21.4256C5.83301 26.3384 9.81562 30.3209 14.7285 30.3209C17.8122 30.3209 20.5294 28.7519 22.1253 26.3684C22.4274 25.9172 22.3317 25.3223 21.9477 24.9383Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 4.00004C14.1663 4.92051 13.4202 5.66671 12.4997 5.66671C11.5792 5.66671 10.833 4.92051 10.833 4.00004C10.833 3.07956 11.5792 2.33337 12.4997 2.33337C13.4202 2.33337 14.1663 3.07956 14.1663 4.00004Z",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledChair);
export default __webpack_public_path__ + "static/media/disabledChair.cb6c55c6b8e4aa743bd1b8dd4e4c25c5.svg";
export { ForwardRef as ReactComponent };